<h1 translate>whitelistDialog.title</h1>
<p translate>whitelistDialog.subtitle</p>
<div class="whitelist-dialog__content">
  <form [formGroup]="searchForm">
    <mat-form-field appearance="outline">
      <mat-label translate>whitelistDialog.input.search</mat-label>
      <input id="searchInputId" matInput formControlName="search" autocomplete="off" />
    </mat-form-field>
  </form>
  <button
    id="searchBtnId"
    mat-stroked-button
    class="whitelist-dialog__search"
    color="accent"
    [disabled]="isDisabledSearchButton"
    (click)="onClickSearch()"
  >
    <span>{{ 'whitelistDialog.btnSearch' | translate | uppercase }}</span>
  </button>
</div>
<mat-dialog-content>
  <mat-radio-group class="whitelist-dialog__list" [(ngModel)]="userSelected">
    <mat-radio-button *ngFor="let user of prescriptorsList" [value]="user">
      {{ user.userId }} - {{ user.businessName }}
    </mat-radio-button>
  </mat-radio-group>
</mat-dialog-content>
<div class="whitelist-dialog__footer">
  <button id="cancelId" mat-dialog-close mat-stroked-button class="whitelist-dialog__search" color="accent">
    <span>{{ 'whitelistDialog.btnCancel' | translate | uppercase }}</span>
  </button>
  <button
    id="selectId"
    mat-flat-button
    class="whitelist-dialog__search"
    color="accent"
    (click)="onClickSelect()"
    [disabled]="isDisabledContinueButton"
  >
    <span>{{ 'whitelistDialog.btnSelect' | translate | uppercase }}</span>
  </button>
</div>
